import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  formInput: {
    file: File | null;
    monthSelected: moment.Moment;
    month: number | null;
    year: number | null;
  };
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  formInput: {
    file: null,
    monthSelected: moment(),
    month: null,
    year: null,
  },
};

const importTimeKeepingSlice = createSlice({
  name: "importTimeKeeping",
  initialState,
  reducers: {
    updateFormImportTimeKeeping: (state, action) => {
      Object.assign(state.formInput, action.payload);
    },
    importTimeKeepingStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    importTimeKeepingSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    importTimeKeepingFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetFormInputImport: () => initialState,
  },
});

export const {
  updateFormImportTimeKeeping,
  importTimeKeepingStart,
  importTimeKeepingSuccess,
  importTimeKeepingFailed,
  resetFormInputImport,
} = importTimeKeepingSlice.actions;

export default importTimeKeepingSlice.reducer;
